// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import WelcomePage from "./components/WelcomePage";
import MatchesPage from "./components/MatchesPage";
import LoadingPage from "./components/LoadingPage";
import ThankYouPage from "./components/ThankYouPage"; 
import "./App.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/loading" element={<LoadingPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/matches" element={<MatchesPage />} />
        <Route path="/done" element={<ThankYouPage />} />
      </Routes>
    </Router>
  );
};

export default App;
